var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[(_vm.textBiggerThanChars)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({},on),[_vm._v(_vm._s(_vm.textFormatted))])]}}],null,false,1241384756)},[_c('span',[_vm._v(_vm._s(_vm.text))])]):_c('span',[_vm._v(_vm._s(_vm.textFormatted))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }